import React, { PropsWithChildren } from 'react';

import './SelectionForm.scss';

export const DialogSection = ({ children }: PropsWithChildren) => {
  return <section className="bulkPartRequestDialogSection">
    {children}
  </section>;
};
